import React, { PureComponent } from 'react';

import './FinanceBackButton.scss';

interface OwnProps {
    onClick: () => void;
}

class FinanceBackButton extends PureComponent<OwnProps> {
    render() {
        return (
            <div className='finance-back' onClick={this.props.onClick}>
                <a className='finance-back__btn'><i className='sa sa-angle-left'></i>Back</a>
            </div>
        );
    }
}

export default FinanceBackButton;